import { ErrorMessage, Field, Form, Formik } from 'formik'
import React from 'react'
import { routes } from '../App'
import { useUserDetails } from '../context'
import { User } from '../interfaces'
import { Button } from '../styled/Button'
import { ContentContainer } from '../styled/ContentContainer'
import { HeaderText } from '../styled/HeaderText'
import { OnboardingHeader } from '../styled/OnboardingHeader'
import { QuestionContainer } from '../styled/QuestionContainer'
import { QuestionTitle } from '../styled/QuestionTitle'

export const CompleteProfile3: React.FC = ({
  history,
  setUserDetails
}: any) => {
  const userDetails = useUserDetails()

  return (
    <div className="App">
      <OnboardingHeader>
        <HeaderText>Complete your profile</HeaderText>
      </OnboardingHeader>
      <Formik
        initialValues={{
          aboutYou: userDetails!.aboutYou,
          profilePictureUrl: userDetails!.profilePictureUrl
        }}
        validate={(values): User => {
          const errors: any = {}
          if (!values.aboutYou) {
            errors.aboutYou = 'Required'
          }
          return errors
        }}
        onSubmit={(values, { setSubmitting }) => {
          setUserDetails((currentValues: any) => ({
            ...currentValues,
            ...values
          }))
          history.push(routes.completeBilling)
        }}
      >
        {({ isSubmitting }) => (
          <ContentContainer>
            <Form>
              <QuestionContainer>
                <QuestionTitle>about you</QuestionTitle>
                <Field
                  type="text"
                  name="aboutYou"
                  component="textarea"
                  autoFocus={true}
                  data-testid="complete-aboutYou-field"
                  rows="2"
                  placeholder="Enter a short bio about yourself (optional)"
                />
                <ErrorMessage name="aboutYou" component="div" />
              </QuestionContainer>
              {/* <QuestionContainer>
                <QuestionTitle>profile picture</QuestionTitle>
                <Field
                  type="number"
                  name="profilePictureUrl"
                  placeholder="Upload a profile picture"
                />
                <ErrorMessage name="profilePictureUrl" component="div" />
              </QuestionContainer> */}
              <Button
                type="submit"
                disabled={isSubmitting}
                data-testid="complete-next"
              >
                Next
              </Button>
            </Form>
          </ContentContainer>
        )}
      </Formik>
    </div>
  )
}
